module.exports = __webpack_public_path__ + "static/media/bgm.20b2b788.mp3";